<mat-card class="widget">
    <div class="fab-buttons">
        <fab-no-title [icon]="'edit'" (click)="edit()"></fab-no-title>
    </div>
    <h1>{{'profile_settings.my_selected_location' | translate}}</h1>
    <div class="azure-map">
        <azure-map #mapelement>
        </azure-map>
    </div>
</mat-card>